import { getURLDate, sortParticipantsByVenueRole } from "./helpers";
const OUTRIGHT_EVENT_TYPE = "Outright";
/**
 * Used for formatting URL's for Sports, Leagues, Events
 * Logic extracted from: Networkpot.DataLayer.Url.UrlFormatter.cs, MasterEventURLHolder.cs
 */
export class UrlFormatter {
    constructor(locale) {
        this.wordSeparator = "-";
        this.cleaner = new RegExp(/(\.+?\)|\[.+?\])/g);
        this.wordBoundaires = [" ", "_", ",", ".", ":", "$", "&"];
        this.skipSymbols = [" ", "\"", "'", "@", "%", "*", "\t", "\n", "\r", "/", "$", "&", "+", ".", ","];
        this.teamSwapAtSeparator = " at ";
        this.teamSwapVsSeparator = " vs ";
        this.locale = locale;
    }
    cleanUrl(name) {
        let formattedUrl = name.toLocaleLowerCase(this.locale).trim().replace(this.cleaner, "");
        let result = [];
        let currentChar = "";
        let startWord = false;
        for (let i = 0; i < formattedUrl.length; i += 1) {
            currentChar = formattedUrl[i];
            if (this.isAfterSeparator(result) && this.isSeparator(currentChar)) {
                continue;
            }
            if (this.wordBoundaires.indexOf(currentChar) >= 0) {
                result = this.addWordBoundaries(startWord, result);
                startWord = true;
            }
            if (this.skipSymbols.indexOf(currentChar) >= 0) {
                continue;
            }
            result.push(currentChar);
            startWord = false;
        }
        return result.join("");
    }
    isAfterSeparator(array) {
        return array.length > 0 ? this.isSeparator(array[array.length - 1]) : false;
    }
    isSeparator(word) {
        return word === this.wordSeparator;
    }
    addWordBoundaries(startWord, result) {
        if (startWord) {
            return result;
        }
        if (!this.isAfterSeparator(result)) {
            result.push(this.wordSeparator);
        }
        return result;
    }
    getSportUrl(sportName) {
        return this.cleanUrl(sportName);
    }
    getLeagueUrl(leagueName) {
        return this.cleanUrl(leagueName);
    }
    getTournamentUrl(tournamentName) {
        return this.cleanUrl(tournamentName);
    }
    getEventUrl(event) {
        if (event.isLive) {
            return event.id;
        }
        const sportName = this.cleanUrl(event.sportName);
        const leagueName = this.cleanUrl(event.leagueName);
        let participants = event.participants.slice().sort(sortParticipantsByVenueRole);
        let swapArray = [0, 1];
        let teamSeparator = this.teamSwapVsSeparator;
        if (event.isTeamSwap) {
            swapArray = swapArray.reverse();
            teamSeparator = this.teamSwapAtSeparator;
        }
        const team1name = participants[swapArray[0]].name;
        const team2name = participants[swapArray[1]].name;
        let eventFullname = `${team1name}${teamSeparator}${team2name}`;
        let eventDate = getURLDate(event.startEventDate);
        if (event.type === OUTRIGHT_EVENT_TYPE) {
            eventFullname = event.eventName;
            eventDate = "";
        }
        const eventName = this.cleanUrl(eventFullname);
        return `${sportName}/${leagueName}${eventDate}/${eventName}`;
    }
}
//# sourceMappingURL=UrlFormatter.js.map